import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { forwardRef } from 'react';

type InputProps = Omit<TextFieldProps, 'error' | 'variant'> & {
  invalid?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ invalid = false, sx, ...props }, ref): JSX.Element => {
    return (
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        error={invalid}
        inputRef={ref}
        sx={[
          {
            '& .MuiOutlinedInput-root': {
              bgcolor: 'background.paper',
            },
            '& .MuiOutlinedInput-root.MuiInputBase-adornedStart': {
              paddingLeft: '16px',
            },
            '& .MuiInputBase-inputAdornedStart': {
              paddingLeft: '10px',
            },
            '& .MuiOutlinedInput-input:-webkit-autofill, & .MuiOutlinedInput-input:-webkit-autofill:hover, & .MuiOutlinedInput-input:-webkit-autofill:focus':
              {
                WebkitTextFillColor: (theme) => theme.palette.text.primary,
                caretColor: (theme) => theme.palette.text.primary,
                WebkitBoxShadow: (theme) =>
                  `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
                boxShadow: (theme) =>
                  `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
                transition: 'background-color 99999s ease-out',
              },
          },
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';
